import { PreventionActionsEnum } from '../enums/PreventionActionsEnum';
import { IPreventionState } from '../interfaces/IPreventionState';
import { PreventionAction } from '../types/PreventionAction';

const initial: IPreventionState = {
  order: '',
  data: [],
  page: 0,
  pageCount: 0,
  totalCount: 0,
  searchValue: '',
  rejected: 0,
};

export function preventionReducer(state = initial, action: PreventionAction) {
  switch (action.type) {
    case PreventionActionsEnum.PREVENTION_SET_ORDER: {
      const newState: IPreventionState = {
        ...state,
        order: action.payload.value,
      };

      return newState;
    }
    case PreventionActionsEnum.PREVENTION_SET_SEARCH_VALUE: {
      const newState: IPreventionState = {
        ...state,
        searchValue: action.payload.value,
      };

      return newState;
    }
    case PreventionActionsEnum.PREVENTION_SET_DATA: {
      const { data, page, totalCount, pageCount, rejected } = action.payload;
      const newState: IPreventionState = {
        ...state,
        data,
        page,
        pageCount,
        totalCount,
        rejected,
      };

      return newState;
    }
    default:
      return state;
  }
}
